import { ReservationActionTypes } from './reservation.types';
import { addItemToReservations, removeItemFromReservations, incrementQty, decrementQty } from './reservation.utils';


const INITIAL_STATE = {
    reservations: [],
    candidate: {}
};

const reservationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
       
        case ReservationActionTypes.ADD_CANDIDATE:
                return {
                    ...state,
                    candidate: action.payload
                };
        case ReservationActionTypes.REMOVE_CANDIDATE:
            return {
                ...state,
                candidate: {},
            };
        case ReservationActionTypes.ADD_RESERVATION:
            return {
                ...state,
                candidate: {},
                reservations: addItemToReservations(action.payload)
            };
        case ReservationActionTypes.REMOVE_RESERVATION:
            return {
                ...state,
                reservations: removeItemFromReservations(state.reservations, action.payload)
            };
        
        case ReservationActionTypes.INCREMENT_QTY:
            return {
                ...state,
                candidate: incrementQty(state.candidate, action.payload)
            };

        case ReservationActionTypes.DECREMENT_QTY:
            return {
                ...state,
                candidate: decrementQty(state.candidate)
            };
        
        case ReservationActionTypes.CLEAR_RESERVATIONS:
            return {
                ...state,
                candidate: {},
                reservations: []
            };
        
        case ReservationActionTypes.UPDATE_USER_RESERVATIONS:
            return {
                ...state,
                reservations: action.payload
            };
        
    
        default:
            return state;
    }
};

export default reservationReducer;